<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/require-v-for-key -->
<!-- eslint-disable vue/no-mutating-props -->

<template>
  <div class="category-carousel">
    <Splide
      ref="catCarousel"
      :options="mainOptions"
      aria-label="Main Gallery Carousel"
    >
      <SplideSlide
        v-for="(category, i) in data"
        :key="i"
      >
        <div class="category-box nRel">
          <img
            :src="category.image"
            alt="category"
          >
          <div class="category-box__content">
            <div class="category-box__icon">
              <img
                :src="category.icon"
                alt="icon"
                width="35"
                height="35"
              >
            </div>
            <h3>{{ category.title }}</h3>
            <span class="divider" />
            <p>
              See All <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="2.03 8.68 28.02 14.62"
                fill="#fff"
                width="22"
                height="12"
              ><path
                d="M22 9a1 1 0 0 0 0 1.42l4.6 4.6H3.06a1 1 0 1 0 0 2h23.52L22 21.59A1 1 0 0 0
                22 23a1 1 0 0 0 1.41 0l6.36-6.36a.88.88 0 0 0 0-1.27L23.42 9A1 1 0 0 0 22 9Z"
                data-name="Layer 2"
              /></svg>
            </p>
          </div>

          <a
            :href="category.link"
            class="nLinkArea"
          />
        </div>
      </SplideSlide>
    </Splide>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { onMounted, ref } from 'vue';

export default {
  components: {
    Splide,
    SplideSlide,
  },
  props: {
    data: Object,
  },
  setup() {
    const catCarousel = ref(Splide);

    const mainOptions = {
      type: 'loop',
      perPage: 5,
      perMove: 1,
      pagination: true,
      arrows: false,
      gap: 20,
      updateOnMove: true,
      focus: 'center',
      padding: {
        right: '10rem',
        left: '10rem',
      },
      breakpoints: {
        1400: {
          perPage: 3,
        },

        991: {
          padding: 0,
        },

        650: {
          perPage: 1,
        },
      },
    };

    onMounted(() => {
      setTimeout(() => {
        if (catCarousel.value && catCarousel.value.splide) {
          catCarousel.value.splide.refresh();
        }
      }, 10);
    });

    return {
      mainOptions,
      catCarousel,
    };
  },
};
</script>
